import {FormGroup} from '@angular/forms';

export abstract class FormGroupFactory {

  protected updateFormGroupValues(formGroup: FormGroup, values: object) {
    Object.keys(values)
      .filter(key => key in formGroup.controls)
      .forEach(key => formGroup.controls[key].setValue((values as Record<string, unknown>)[key]));
  }

}
